import vuetify from '@/plugins/vuetify';

// Global Functions
const isMobile = function() {
  if (vuetify.framework) {
    return (vuetify.framework as any).breakpoint.smAndDown;
  } else {
    return false;
  }
};
const isSmallMobile = function() {
  return (vuetify as any).framework.breakpoint.xsOnly;
};
const isBigScreen = function() {
  return (vuetify as any).framework.breakpoint.width >= 960;
};

export { isMobile, isSmallMobile, isBigScreen };
